import React, { useEffect, useState, useRef } from "react";
import {
  Offcanvas,
  Card,
  Container,
  Row,
  Toast,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import api from "../../../seller-apis/api";
import {
  approvedProducts,
  activeProductFilter, //SL-975
} from "../../../seller-apis/apidataField";
import ProductCard from "../../common/ProductCard";
import Popup from "../../common/Popup";
import UpdtProPopup2 from "../../common/UpdtProPopup2";
import "../../inventry.css";
import { useAlert } from "react-alert";
import { NavLink } from "react-router-dom";
import { variables } from "../../../Variables.json";
import PaginationNew from "../../common/Pagination";
import ProductSearch from "../../common/ProductSearch";
import ProductSKUSearch from "../../common/ProductSearch/ProductSKUSearch";
import MatchPriceModal from "../../common/MatchPriceModal";
import BulkStockHandler from "../../common/BulkStockHandler";
import NewPriceReqPopup from "../../common/NewPriceReqPopup";
import { saveVendorStock } from "../../../services/vendor.service";
import PriceSortDropdown from "./Pricesortdropdown";

var globalFilter = {
  pageNo: 1,
  //SL-975
  status: {
    active: true,
  },
  stockSts: {
    $or: [
      {
        $and: [
          {
            $or: [
              { combination: { $exists: false } },
              { combination: { $size: 0 } }
            ]
          },
          { stock: { $gt: 0 } }
        ]
      },
      {

        $and: [
          { combination: { $exists: true, $ne: [] } },
          //Has at least one combo with purchase_price & stock > 0
          { combination: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, stock: { $gt: 0 } } } },
          //No combo with purchase_price & stock == 0
          { combination: { $not: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, $or: [{ stock: 0 }, { stock: { $exists: false } }] } } } }
          //{ "combination.purchase_price" : { $exists: true, $ne: null }},
          //{ "combination.stock": { $gt : 0 } },
        ]
      },
    ],
  },
  prStatus: {
    $or: [
      {
        $and: [
          {
            $or: [
              { combination: { $exists: false } },
              { combination: { $size: 0 } }
            ]
          },
          { prSts: { $ne: "V_PENDING" } }
        ]
      },
      {

        $and: [
          { combination: { $exists: true, $ne: [] } },
          { "combination.purchase_price": { $exists: true, $ne: null } },
          { "combination.prSts": { $ne: "V_PENDING" } },
        ]
      },
    ],
  },
  weightStatus: {
    $or: [
      {
        $and: [
          {
            $or: [
              { combination: { $exists: false } },
              { combination: { $size: 0 } }
            ]
          },
          { sellerWeightChangeSts: { $ne: "V_PENDING" } }
        ]
      },
      {

        $and: [
          { combination: { $exists: true, $ne: [] } },
          { "combination.purchase_price": { $exists: true, $ne: null } },
          { "combination.sellerWeightChangeSts": { $ne: "V_PENDING" } },
        ]
      },
    ],
  },
  fieldFilters:{
    images:{
      baseImage: true
    }
  },
  selectFields:{
    pkgs:-1,
    lowestPkgs:-1,
    videos:-1
  }
};

const getActivePurchasePrice = (product) => {
  // Check if product has combinations
  if (product?.vendors?.[0]?.combination && product.vendors[0].combination.length > 0) {
    // For combination products, find the first active combination with stock > 0
    const activeCombination = product.vendors[0].combination.find(
      combo => (combo.vActive === "ACTIVE" || combo.vActive === "INACTIVE_REQ") && 
               combo.stock > 0 && 
               combo.purchase_price
    );
    
    if (activeCombination) {
      return activeCombination.purchase_price;
    }
    
    // Fallback to first combination with purchase_price
    const firstCombo = product.vendors[0].combination.find(combo => combo.purchase_price);
    if (firstCombo) {
      return firstCombo.purchase_price;
    }
  }
  
  // For regular products or fallback
  return product?.vendors?.[0]?.purchase_price || 0;
};

/**
 * Sort products by price (client-side)
 * This ensures proper sorting for both regular and combination products
 */
const sortProductsByPrice = (products, order) => {
  if (!order) return products;
  
  return [...products].sort((a, b) => {
    const priceA = getActivePurchasePrice(a);
    const priceB = getActivePurchasePrice(b);
    
    if (order === 'asc') {
      return priceA - priceB;
    } else {
      return priceB - priceA;
    }
  });
};

// sale filter
let saleFilter = null;

function ActiveProducts() {
  var outerdiv;
  var loaderDiv;

  const alert = useAlert();
  var curUrl = window.location.pathname.split("/");
  // Size states

  const [currView, setcurrView] = useState();
  const [approvedProductsList, setapprovedProductsList] = useState([]);
  const [appRecords, setappRecords] = useState();
  const [curURL, setCurURL] = useState();

  // Pagination related


  const [selectedPage, setselectedPage] = useState(1);
  const [compforPaginationweb, setcompforPaginationweb] = useState("approvedPro")

  // Popup related states
  const [updtProVisibility, setupdtProVisibility] = useState(false);
  const [clickedUpdateNo, setCickedUpdateNo] = useState();
  const [selectedProductPopup, setselectedProductPopup] = useState();
  const [selectedImgPopup, setselectedImgPopup] = useState();
  const [updtPopuprel, setupdtPopuprel] = useState([]);

  // Confirmation Related States

  const [confirmationState, setconfirmationState] = useState(false);
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [selectedProduct, setselectedProduct] = useState();
  const [selectedId, setselectedId] = useState();
  const [activDeactiveState, setactivDeactiveState] = useState();
  const [deactiveReason, setdeactiveReason] = useState(false);


  // Loader state
  const [loaderProduct, setloaderProduct] = useState("block");


  // Popup related

  const [isPopupVisible, setisPopupVisible] = useState("block");
  const [isPopupVisiblePendfapp, setisPopupVisiblePendfapp] = useState("block");
  const [productNo, setproductNo] = useState(0);

  // Toast
  const [showToast, setshowToast] = useState(false);
  const [ToastMsg, setToastMsg] = useState();
  // Combination related

  const [combAttri, setcombAttri] = useState([]);
  const [currentProupdt, setcurrentProupdt] = useState();

  // Detail popup
  const [currDetail, setcurrDetail] = useState(0);
  const [currDetailPend, setcurrDetailPend] = useState(0);

  // Web search
  const [searchPro, setsearchPro] = useState();

  const [isTabCheck, setisTabCheck] = useState();

  // Verify transfer price

  const [offcanshow, setoffcanshow] = useState(false);
  const [offcanstate, setoffcanstate] = useState("ask");
  const [newoffcanPrice, setnewoffcanPrice] = useState();
  const [seloption, setseloption] = useState("continueSame");
  const [curroffCanPrice, setcurroffCanPrice] = useState();
  const [offcanspcl, setoffcanspcl] = useState();
  const [offcancurrId, setoffcancurrId] = useState();
  const [taxClass, settaxClass] = useState();
  const [searchType, setSearchType] = useState("Product Name");
  // Lowest price

  const [lowestPrice, setlowestPrice] = useState(undefined)

  // Filter State
  const [currstatussort, setcurrstatussort] = useState("Status*")
  const [currpricesort, setcurrpricesort] = useState("Status*")
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [matchObject, setMatchObject] = useState(false);

  const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")
  //SL-675
  const [totalRcordId, setTotalReordId] = useState([]);
  const [resetSearchType, setResetSearchType] = useState(0);

  // SL-906
  const [newPricePopupShow, setNewPricePopupShow] = useState(false);
  const [curPricePopupLead, setCurPricePopupLead] = useState(false);
  const [curPricePopupUrl, setCurPricePopupUrl] = useState(false);
  const [curPricePopupPrice, setCurPricePopupPrice] = useState(false);
  const [curPricePopupGst, setCurPricePopupGst] = useState(false);
  const [curPricePopupCombState, setCurPricePopupCombState] = useState(false);

  // Price sorting state
  const [priceSortOrder, setPriceSortOrder] = useState(null); // null, 'asc', or 'desc'
  const updateSearchCountRef = useRef(null);


  const searchParam = {
    //"vendors": { "$elemMatch": { "$and": [{ "vActive": { "$exists": true } }, { "$or": [{ "vActive": { "$in": ["ACTIVE", "INACTIVE_REQ"] } }, { "combination.vActive": "ACTIVE" }] }, { "active": true }, { "$and": [{ "prSts": { "$exists": true } }, { "prSts": { "$ne": "V_PENDING" } }] }, { "vActive": { "$ne": "REJECT" } }] } }
  };

  const getPriceMatchObject = (data) => {

    setShowMatchModal(true);
    setMatchObject(data)
  }
  const closeMatchModal = () => {
    setShowMatchModal(false);

  }
  useEffect(() => {
    getProducts();
  }, []);
  
  const getProducts = () => {
    globalFilter = {
      ...globalFilter,
      pageNo: 1,
      //SL-975
      status: {
    active: true,
      },
       stockSts: {
              $or: [
                      {
                        $and:[
                          {
                            $or:[
                                {combination : {$exists : false}},
                                {combination : {$size : 0}}
                            ]
                          },
                          { stock: {$gt : 0 }}
                        ]
                      },
                      {
                          
                        $and : [
                          { combination: { $exists: true, $ne: [] } },
                          //Has at least one combo with purchase_price & stock > 0
                          { combination: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, stock: { $gt: 0 } } } },
                          //No combo with purchase_price & stock == 0
                          { combination: { $not: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, $or: [{ stock: 0 }, { stock: { $exists: false }}] } } } }
                          //{ "combination.purchase_price" : { $exists: true, $ne: null }},
                          //{ "combination.stock": { $gt : 0 } },
                        ]
                      },
              ],
        },
        prStatus: {
              $or: [
                      {
                        $and:[
                          {
                            $or:[
                                {combination : {$exists : false}},
                                {combination : {$size : 0}}
                            ]
                          },
                          { prSts: {$ne : "V_PENDING" }}
                        ]
                      },
                      {
                          
                        $and : [
                          { combination: { $exists: true, $ne: [] } },
                          { "combination.purchase_price" : { $exists: true, $ne: null }},
                          { "combination.prSts": { $ne : "V_PENDING"} },
                        ]
                      },
                ],
        },
        weightStatus: {
              $or: [
                      {
                        $and:[
                                {
                                  $or:[
                                        {combination : {$exists : false}},
                                        {combination : {$size : 0}}
                                  ]
                                },
                                {  sellerWeightChangeSts: { $ne : "V_PENDING" }}
                        ]
                      },
                      {
                          
                        $and : [
                                { combination: { $exists: true, $ne: [] } },
                                { "combination.purchase_price" : { $exists: true, $ne: null }},
                                { "combination.sellerWeightChangeSts": { $ne : "V_PENDING" }},
                        ]
                      },
              ],
        }
    };
    setisTabCheck(true);
    setselectedPage(1);
    let size = window.innerWidth;
    if (size > 768) {
      setcurrView("laptop");
    } else {
      setcurrView("mobile");
    }
    // Approved Products
    //SL-675
    globalFilter["productId"] = totalRcordId.length == 0 ? true : false;
    
    // Add price sorting if active
    if (priceSortOrder) {
      globalFilter["priceSort"] = priceSortOrder;
    }

    //add sale filter
    if (saleFilter !== null) {
      globalFilter["saleFilter"] = saleFilter;
    }
    
    api.product
      //SL-975
      //.productsRetrieveall(approvedProducts(globalFilter))
      .productsRetrieveall(activeProductFilter(globalFilter))
      .then((res) => {

        const sortedProducts = priceSortOrder 
          ? sortProductsByPrice(res.products, priceSortOrder)
          : res.products;

        setapprovedProductsList(sortedProducts);
        setappRecords(res.totalRecords);
        if (totalRcordId.length == 0) {//SL-675
          setTotalReordId(res?.productId);
          globalFilter["productId"] = false;
        }
        setloaderProduct("none");
      })
      .catch((err) => {
        setloaderProduct("none");
        console.log(err);
      });
  }

  function productCheck(e) {
    setcombAttri([]);
    for (let i = 0; i < approvedProductsList.length; i++) {
      let baseImg;
      if (approvedProductsList[i]._id === e) {

        setselectedProductPopup(approvedProductsList[i].productName);
        if (approvedProductsList[i].attributeList) {
          if (approvedProductsList[i].attributeList.length > 0) {
            setcombAttri(approvedProductsList[i].attributeList);
            setcurrentProupdt(approvedProductsList[i]);
          }
        }
        setupdtPopuprel({
          SKU: approvedProductsList[i].SKU,
          price: approvedProductsList[i].vendors[0].purchase_price,
        });
        approvedProductsList[i].images.map((item) => {
          if (item.baseImage === true) {
            if (item.image.startsWith("products")) {
              baseImg = item.image;
              setselectedImgPopup(baseImg);
            } else {
              let img = item.image.substr("41");
              baseImg = img;
              setselectedImgPopup(baseImg);
            }
          }
        });

        setCickedUpdateNo(e);
        setupdtProVisibility(true);
      }
    }
  }

  function checkpopupvisibility(e) {
    if (e === false) {
      setupdtProVisibility(false);
    } else {
      setupdtProVisibility(true);
    }
  }
  // Pagination function

  function paginate(data) {
    applyLoader();
    setproductNo(0);
    setcurrDetail(0);
    globalFilter.pageNo = data.number;
    setselectedPage(data.number);

    // Add price sorting if active
    if (priceSortOrder) {
      globalFilter["priceSort"] = priceSortOrder;
    }

    // Approved Products
    api.product
      //SL-975
      //.productsRetrieveall(approvedProducts(globalFilter))
      .productsRetrieveall(activeProductFilter(globalFilter))
      .then((res) => {
        setapprovedProductsList(res.products);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }

  // apply loaders

  function applyLoader() {
    outerdiv = document.getElementById("orDeskContain");
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setloaderProduct("flex");
    outerdiv.classList.add("div-bk");
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setloaderProduct("none");
    outerdiv.classList.remove("div-bk");
  }


  // Toggle

  function changeproductStatus(id, status) {
    let quantity;
    for (let i = 0; i < approvedProductsList.length; i++) {
      if (approvedProductsList[i]._id === id) {
        setselectedProduct(approvedProductsList[i].productName);
        quantity = approvedProductsList[i].vendors[0].stock;
      }
    }
    if (status === "on") {
      setdeactiveReason(false);
      setactivDeactiveState("activate");
      setselectedId(id);
      setmsgConfirmation("Are you sure you want to activate this product");
      setconfirmationState(true);
      // }
    } else if (status === "off") {

      setdeactiveReason(true);
      setactivDeactiveState("deactivate");
      setselectedId(id);
      setmsgConfirmation("Are you sure you want to deactivate this product");
      setconfirmationState(true);
    }
  }

  // Update response

  function callbackResUpdate(res) {
    if (res === "product updated") {
      applyLoader();
      setapprovedProductsList([])
      
      // Add price sorting if active
      if (priceSortOrder) {
        globalFilter["priceSort"] = priceSortOrder;
      }
      
      api.product
        //SL-975
        //.productsRetrieveall(approvedProducts(globalFilter))
        .productsRetrieveall(activeProductFilter(globalFilter))
        .then((res) => {
          if (res.totalRecords > 0) {
            setapprovedProductsList(res.products);
            setappRecords(res.totalRecords);
          }
          removeLoader();
        })
        .catch((err) => {
          console.log(err);
          removeLoader()
        });
      alert.success("Product updated");
      setupdtProVisibility(false);
    } else {
      alert.error("Failed to update");
      setupdtProVisibility(false);
    }
  }

  //  Control view acc to size
  function handleResize() {
    if (window.innerWidth > 700) {
      setcurrView("laptop");
    } else {
      setcurrView("mobile");
    }
  }

  window.addEventListener("resize", handleResize);

  //   Popup related functions

  function setpopupVisibility(e, from) {

    if (from) {
      if (e > -1) {
        setcurrDetailPend(e);
        setisPopupVisiblePendfapp("block");
      } else {

        setisPopupVisiblePendfapp("none");
        setisPopupVisible("none");
      }
    } else {
      if (e > -1) {

        setcurrDetail(e);
        setisPopupVisible("block");
      } else {

        setisPopupVisible("none");
        setisPopupVisiblePendfapp("none");
      }
    }
  }

  function henfun(e) {
    setproductNo(0);

    setproductNo(e);
  }

  // Search on enter web

  function checkevent(e) {
    if (e.keyCode === 13) {
      //SL-696
      let filterProduct = {
        "pageNo": 1,
        "size": 12,
        "filter": {}
      }
      let outerdiv = document.getElementById("orDeskContain");
      let loaderDiv = document.getElementById("enNewLoader");
      console.log('searchPro',searchPro)
      if (searchPro !== "" && searchPro !== undefined) {
        let ordersearchFilter = searchType != 'sku' ? { "_id-objectId": searchPro } : { "_id-objectId": searchPro };
        filterProduct.filter = {
          ...ordersearchFilter,
        };
        outerdiv.classList.add("div-bk");
        loaderDiv.classList.add("loader-bt");
        setloaderProduct("block");
        setselectedPage(1);
        globalFilter.pageNo = "1"
        setcompforPaginationweb("appsearchPro");
        api.product
          .productsRetrieveall(filterProduct)
          .then((res) => {
            setremoveFilterClass("invent_remove_filter_btn_active");
            setapprovedProductsList(res.products);
            setappRecords(res.totalRecords);
            outerdiv.classList.remove("div-bk");
            setloaderProduct("none");
            loaderDiv.classList.remove("loader-bt");
          })
          .catch((err) => {
            outerdiv.classList.remove("div-bk");
            loaderDiv.classList.remove("loader-bt");
            console.log(err);
            setloaderProduct("none");
          });
      } else if (compforPaginationweb !== "approvedPro") {
        globalFilter.filters = {};
        setloaderProduct("block");
        outerdiv.classList.add("div-bk");
        loaderDiv.classList.add("loader-bt");
        setselectedPage(1);
        globalFilter.pageNo = "1"
        setcompforPaginationweb("approvedPro");
        
        // Add price sorting if active
        if (priceSortOrder) {
          globalFilter["priceSort"] = priceSortOrder;
        }
        
        api.product
          //SL-975
          //.productsRetrieveall(approvedProducts(globalFilter))
          .productsRetrieveall(activeProductFilter(globalFilter))
          .then((res) => {
            if (currstatussort === "Status*" && currpricesort === "Status*") {
              setremoveFilterClass("invent_remove_filter_btn");
            } else {
              setremoveFilterClass("invent_remove_filter_btn_active");
            }
            outerdiv.classList.remove("div-bk");
            loaderDiv.classList.remove("loader-bt");

            setapprovedProductsList(res.products);
            setappRecords(res.totalRecords);
            setloaderProduct("none");
          })
          .catch((err) => console.log(err));
        outerdiv.classList.remove("div-bk");
        loaderDiv.classList.remove("loader-bt");
        setloaderProduct("none");
      }
    }
  }

  // Offcanvas show/hide
  const handleCloseoffcan = () => {
    setnewoffcanPrice()
    setoffcanshow(false)
    setoffcanstate("ask")
  }
  const handleopenoffcan = () => setoffcanshow(true);

  // Off canvas ask new price 

  const checkNewPrice = () => {
    if (newoffcanPrice === undefined || newoffcanPrice === "" || newoffcanPrice < 1) {
      alert.info("Please enter a valid new price.")
    }
    else {
      setoffcanstate("jhdf")
    }
  }

  // New price request fun offcanvas 2 state

  const newPriceReq = () => {
    document.getElementById("sub_newreq").disabled = true

    if (seloption === undefined || seloption === "") {
      alert.info("Please select one option")
      document.getElementById("sub_newreq").disabled = false
    }
    else {
      handleCloseoffcan()

      if (seloption === "continueSame") {
        let data = {
          "prInActive": false,
          "product": offcancurrId,
          "price": newoffcanPrice
        }
        api.transferprice.priceChangeRquest(data).then((res => {
          if (res.message === "price change request submitted") {
            alert.success("New price request successfully sent to Toolsvilla")
            alert.success("Transfer Price verified")
            let filter = {
              "pageNo": "1"
            }
            setselectedPage(1)
            globalFilter.pageNo = "1"
            
            // Add price sorting if active
            if (priceSortOrder) {
              globalFilter["priceSort"] = priceSortOrder;
            }
            
            // Approved Products
            //SL-975
            //api.product.productsRetrieveall(approvedProducts(globalFilter))
            api.product.productsRetrieveall(activeProductFilter(globalFilter))
              .then((res) => {

                setapprovedProductsList(res.products)
                setappRecords(res.totalRecords)
              })
              .catch(err => console.log(err))
          }
          else {
            alert.info(res.message)
          }

        })).catch(err => console.log(err))
      }
      else {
        let data = {
          "prInActive": true,
          "product": offcancurrId,
          "price": newoffcanPrice
        }
        api.transferprice.priceChangeRquest(data).then((res => {
          if (res.message === "price change request submitted") {
            alert.success("New price request successfully sent to Toolsvilla")
            alert.success("Transfer Price verified")
            let filter = {
              "pageNo": "1"
            }
            setselectedPage(1)
            globalFilter.pageNo = "1"
            
            // Add price sorting if active
            if (priceSortOrder) {
              globalFilter["priceSort"] = priceSortOrder;
            }
            
            // Approved Products
            //SL-975
            //api.product.productsRetrieveall(approvedProducts(globalFilter))
            api.product.productsRetrieveall(activeProductFilter(globalFilter))
              .then((res) => {

                setapprovedProductsList(res.products)
                setappRecords(res.totalRecords)
              })
              .catch(err => console.log(err))
          }
          else {
            alert.info(res.message)
          }
          handleCloseoffcan()
        })).catch(err => console.log(err))
      }
      document.getElementById("sub_newreq").disabled = false
    }
  }


  // Verify transfer price after 1 popup

  function noVerifyPrice() {
    setoffcanstate("askNewPrice")
  }


  function yesVerifyPrice() {
    if (offcanspcl === "oldPros") {
      let data = {
        "_id": offcancurrId,
        "purchase_price": curroffCanPrice,
        "prSts": "V_ACTIVE"
      }
      api.product.addToExProduct(data).then((res) => {

        if (res.message === "product updated") {
          alert.success("Transfer Price verified")
          let filter = {
            "pageNo": "1"
          }
          setselectedPage(1)
          globalFilter.pageNo = "1"
          
          // Add price sorting if active
          if (priceSortOrder) {
            globalFilter["priceSort"] = priceSortOrder;
          }
          
          // Approved Products
          //SL-975
          //api.product.productsRetrieveall(approvedProducts(globalFilter))
          api.product.productsRetrieveall(activeProductFilter(globalFilter))
            .then((res) => {

              setapprovedProductsList(res.products)
              setappRecords(res.totalRecords)
              handleCloseoffcan()
            })
            .catch(err => console.log(err))
        }
        else {
          alert.info("Error")
        }
      }).catch(err => console.log(err))
    }
    else {
      let data = {
        "product": offcancurrId,
        "purchase_price": curroffCanPrice,
        "status": "V_ACTIVE"
      }
      api.transferprice.updatePriceRequest(data).then((res) => console.log(res)).catch(err => console.log(err))
    }
  }

  // Verfiy Transfer Price

  const verifyTransferPrice = (id, price, spcl, lowestPrice, taxCs) => {


    setoffcancurrId(id)
    setcurroffCanPrice(price)
    setoffcanspcl(spcl)
    setlowestPrice(lowestPrice)
    settaxClass(taxCs)
    handleopenoffcan()

  }



  // Function to close all popups opened

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key === "Esc" || evt.key === "Escape") {
      setisPopupVisible("none")
      setupdtProVisibility(false)
      setoffcanshow(false)
      setisPopupVisiblePendfapp("none")

    }
  };

  // Clear Filters

  function clearFilters() {
    if (
      globalFilter.filters ||
      globalFilter.prSts ||
      globalFilter.status ||
      globalFilter.prStatus
    ) {
      applyLoader();
      setselectedPage(1);
      globalFilter = {
        pageNo: 1,
        //SL-975
        status: {
    active: true,
        },
       stockSts: {
        $or: [
                {
                  $and:[
                    {
                      $or:[
                          {combination : {$exists : false}},
                          {combination : {$size : 0}}
                      ]
                    },
                    { stock: {$gt : 0 }}
                  ]
                },
                {
                    
                  $and : [
                    { combination: { $exists: true, $ne: [] } },
                    //Has at least one combo with purchase_price & stock > 0
                    { combination: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, stock: { $gt: 0 } } } },
                    //No combo with purchase_price & stock == 0
                    { combination: { $not: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, $or: [{ stock: 0 }, { stock: { $exists: false }}] } } } }
                    //{ "combination.purchase_price" : { $exists: true, $ne: null }},
                    //{ "combination.stock": { $gt : 0 } },
                  ]
                },
          ],
        },
        prStatus: {
              $or: [
                      {
                        $and:[
                          {
                            $or:[
                                {combination : {$exists : false}},
                                {combination : {$size : 0}}
                            ]
                          },
                          { prSts: {$ne : "V_PENDING" }}
                        ]
                      },
                      {
                          
                        $and : [
                          { combination: { $exists: true, $ne: [] } },
                          { "combination.purchase_price" : { $exists: true, $ne: null }},
                          { "combination.prSts": { $ne : "V_PENDING"} },
                        ]
                      },
                ],
        },
        weightStatus: {
              $or: [
                      {
                        $and:[
                                {
                                  $or:[
                                        {combination : {$exists : false}},
                                        {combination : {$size : 0}}
                                  ]
                                },
                                {  sellerWeightChangeSts: { $ne : "V_PENDING" }}
                        ]
                      },
                      {
                          
                        $and : [
                                { combination: { $exists: true, $ne: [] } },
                                { "combination.purchase_price" : { $exists: true, $ne: null }},
                                { "combination.sellerWeightChangeSts": { $ne : "V_PENDING" }},
                        ]
                      },
              ],
        }
      };
      setcurrpricesort("Status*");
      setcurrstatussort("Status*");
      setsearchPro("");
      
      // Add price sorting if active
      if (priceSortOrder) {
        globalFilter["priceSort"] = priceSortOrder;
      }
      
      api.product
        //SL-975
        //.productsRetrieveall(approvedProducts(globalFilter))
        .productsRetrieveall(activeProductFilter(globalFilter))
        .then((res) => {
          setremoveFilterClass("invent_remove_filter_btn");
          setapprovedProductsList(res.products);
          setappRecords(res.totalRecords);
          if (res.totalRecords < 1) {
            alert.info("No Records Found");
          }
          removeLoader();
        })
        .catch((err) => console.log(err));
    }
  }
  const filterSearch = (data) => {
    //setsearchPro(data.data);
    //setSearchType(data.type)
    globalFilter['filters'] = { ...globalFilter.filters, "_id-objectId": data.data }
    if (globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = 1;
    
    // Add price sorting if active
    if (priceSortOrder) {
      globalFilter["priceSort"] = priceSortOrder;
    }
    
    //SL-975
    //api.product.productsRetrieveall(approvedProducts(globalFilter))
    api.product.productsRetrieveall(activeProductFilter(globalFilter))
      .then((res) => {
        setapprovedProductsList(res.products);
        setappRecords(res.totalRecords);
        setloaderProduct("none");
      })
      .catch((err) => {
        setloaderProduct("none");
        console.log(err);
      });
    if (globalFilter?.filters && globalFilter['filters']['_id-objectId'])
      delete globalFilter['filters']['_id-objectId'];

  }

  useEffect(() => {
    checkevent({ "keyCode": 13 }, "appPro");
  }, [searchPro])

const handleCountUpdate = (updateFn) => {
  updateSearchCountRef.current = updateFn;
};

   //SL-699 : Seller Stock Update
  // l1-2341 (10-9-25)
  async function updateSellerStock(id, stock, url, index, combination) {
    let sitePrice;


    let data = {
      "_id": id,
      "stock": stock,
      "vActive": "ACTIVE",
      "reason": ""
    }
    let msg = "Stock Updated Successfully!";
    //if given 0, then out of stock
    if (stock == 0) {
      data["vActive"] = "INACTIVE";
      data["reason"] = "Out Of Stock";
      msg = "Stock updated and Product moved to Out Of Stock tab."
    }

    try {
      // l1-2341(10-9-25)
      if (url !== undefined && url !== null) {
        data["url"] = url;
        sitePrice = combination?.sitePrice;
        if (Number(combination?.stock) < 1 && stock > 0) {
          await handleSaveVendorStock(id, stock, url, index, combination, "In Stock", combination?.price, sitePrice);
        }
        else if (Number(stock) === 0) {
          await handleSaveVendorStock(id, stock, url, index, combination, "Out Of Stock", combination?.price, sitePrice);
        }
      }
      else {
        let prevStock = approvedProductsList[index]?.vendors?.[0]?.stock || 0
        let stockStatus = (Number(stock) > 0) ? "In Stock" : "Out Of Stock"
        sitePrice = approvedProductsList[index]?.specialPrice ? approvedProductsList[index]?.specialPrice : approvedProductsList[index]?.price;
        (Number(stock) === 0 || Number(prevStock) < 1) && await handleSaveVendorStock(id, stock, url, index, combination, stockStatus, approvedProductsList[index]?.vendors?.[0]?.purchase_price, sitePrice);
      }

      // Only call addToExProduct if saveVendorStock succeeded
      api.product.addToExProduct(data).then((res) => {
        alert.success(msg)
        setselectedPage(1)
        globalFilter.pageNo = "1"
        
        // Add price sorting if active
        if (priceSortOrder) {
          globalFilter["priceSort"] = priceSortOrder;
        }
        
        // Approved Products
        //SL-975
        //api.product.productsRetrieveall(approvedProducts(globalFilter))
        api.product.productsRetrieveall(activeProductFilter(globalFilter))
          .then((res) => {
            setapprovedProductsList(res.products)
            setappRecords(res.totalRecords)
            handleCloseoffcan()
          })
          .catch(err => console.log(err))


      }).catch(err => console.log(err))
    } catch (err) {
      // If saveVendorStock failed, don't call addToExProduct
      console.log("Stock update aborted due to vendor stock error:", err)
    }

  }


  const handleSaveVendorStock = async (id, stock, url, index, combination, stockStatus, price, site_price) => {
    try {
      let data = {
        "product": approvedProductsList[index]?._id,
        "vendor": approvedProductsList[index]?.vendors?.[0]?.vendor_id,
        "taxClass": approvedProductsList[index]?.vendors?.[0]?.taxClass,
        "purchase_price": price,
        "stock": stock,
        "status": "AUTOAPPROVED",
        "stockStatus": stockStatus,
        "site_price": site_price,
        "categories": approvedProductsList[index]?.categories,
        "receivedFrom":"seller"
      }
      if (url) {
        data["combination.url"] = combination?.url
      }
      await saveVendorStock(data)
    } catch (err) {
      console.log(err)
      alert.error(err.message || "Failed to update stock status");
      // Re-throw the error so the calling function knows it failed
      throw err;
    }
  }

  // l1-2319 (2-9-26)
  async function updateProductHSN(id, hsn) {
    let data = {
      "_id": id,
      "HSN": hsn
    }
    try {

      let res = await api.product.addToExProduct(data);
      if (
        res.message === "product updated" ||
        res.message === "product added") {
        ApiCalling();
        alert.success("HSN Updated Successfully!");
      }
      else {
        alert.info(res.message);
      }
    }
    catch (err) {
      alert.info("Failed to update HSN");
      console.log(err);
    }
  }

  /**
   * API Calling
   */
  const ApiCalling = () => {
    if (globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = selectedPage;
    
    // Add price sorting if active
    if (priceSortOrder) {
      globalFilter["priceSort"] = priceSortOrder;
    }
    
    //SL-975
    //api.product.productsRetrieveall(approvedProducts(globalFilter))
    api.product.productsRetrieveall(activeProductFilter(globalFilter))
      .then((res) => {
        setapprovedProductsList(res.products);
        setappRecords(res.totalRecords);
        setloaderProduct("none");
      })
      .catch((err) => {
        setloaderProduct("none");
        console.log(err);
      });

  }




  //<Start-Here> Search Issue Ticket: SL-696
  const gotoCurrentPage = () => {
    applyLoader();
    setsearchPro("");
    const globalFilter = {
      pageNo: selectedPage,
      //SL-975
      status: {
    active: true,
      },
        stockSts: {
        $or: [
                {
                  $and:[
                    {
                      $or:[
                          {combination : {$exists : false}},
                          {combination : {$size : 0}}
                      ]
                    },
                    { stock: {$gt : 0 }}
                  ]
                },
                {
                    
                  $and : [
                    { combination: { $exists: true, $ne: [] } },
                    //Has at least one combo with purchase_price & stock > 0
                    { combination: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, stock: { $gt: 0 } } } },
                    //No combo with purchase_price & stock == 0
                    { combination: { $not: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, $or: [{ stock: 0 }, { stock: { $exists: false }}] } } } }
                    //{ "combination.purchase_price" : { $exists: true, $ne: null }},
                    //{ "combination.stock": { $gt : 0 } },
                  ]
                },
          ],
        },
        prStatus: {
              $or: [
                      {
                        $and:[
                          {
                            $or:[
                                {combination : {$exists : false}},
                                {combination : {$size : 0}}
                            ]
                          },
                          { prSts: {$ne : "V_PENDING" }}
                        ]
                      },
                      {
                          
                        $and : [
                          { combination: { $exists: true, $ne: [] } },
                          { "combination.purchase_price" : { $exists: true, $ne: null }},
                          { "combination.prSts": { $ne : "V_PENDING"} },
                        ]
                      },
                ],
        },
        weightStatus: {
              $or: [
                      {
                        $and:[
                                {
                                  $or:[
                                        {combination : {$exists : false}},
                                        {combination : {$size : 0}}
                                  ]
                                },
                                {  sellerWeightChangeSts: { $ne : "V_PENDING" }}
                        ]
                      },
                      {
                          
                        $and : [
                                { combination: { $exists: true, $ne: [] } },
                                { "combination.purchase_price" : { $exists: true, $ne: null }},
                                { "combination.sellerWeightChangeSts": { $ne : "V_PENDING" }},
                        ]
                      },
              ],
        }
    };
    
    // Add price sorting if active
    if (priceSortOrder) {
      globalFilter["priceSort"] = priceSortOrder;
    }

    // Approved Products
    api.product
      //SL-975
      //.productsRetrieveall(approvedProducts(globalFilter))
      .productsRetrieveall(activeProductFilter(globalFilter))
      .then((res) => {
        setapprovedProductsList(res.products);
        setappRecords(res.totalRecords);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }
  //</End-Here> Search Issue Ticket: SL-696

 /**
  * Search By Keyword On Enter
  */
  const searchByKeyword = (value, type, productIds) => {

  if (productIds.length > 0) {
    globalFilter['searchIds'] = productIds
    //Search Issue on Other than 1st Page SL-698 and SL-675
    globalFilter.pageNo = 1;
    setselectedPage(1)
    
    // Add price sorting if active
    if (priceSortOrder) {
      globalFilter["priceSort"] = priceSortOrder;
    }
    
    //SL-975
    //api.product.productsRetrieveall(approvedProducts(globalFilter))
    api.product.productsRetrieveall(activeProductFilter(globalFilter))
      .then((res) => {
        setapprovedProductsList(res.products);
        setappRecords(res.totalRecords);
        
        // ✅ Update the search component's count display with accurate value
        if (updateSearchCountRef.current) {
          updateSearchCountRef.current(res.totalRecords);
        }
        
        setloaderProduct("none");
      })
      .catch((err) => {
        setloaderProduct("none");
        console.log(err);
      });

  }
  else {
    setappRecords(0);
    setapprovedProductsList([]);
    
    // ✅ Update the search component's count display
    if (updateSearchCountRef.current) {
      updateSearchCountRef.current(0);
    }
  }
}

  // HSN Filter handler
  const handleHSNFilterChange = (hsnFilter) => {
  if (hsnFilter) {
    globalFilter = {
      ...globalFilter,
      hsnFilter: hsnFilter
    };
  } else {
    // Remove hsnFilter from globalFilter
    const { hsnFilter, ...filterWithoutHSN } = globalFilter;
    globalFilter = filterWithoutHSN;
  }
  globalFilter.pageNo = 1;
  setselectedPage(1);
  
  // Add price sorting if active
  if (priceSortOrder) {
    globalFilter["priceSort"] = priceSortOrder;
  }
  
  // Call API and update count
  api.product.productsRetrieveall(activeProductFilter(globalFilter))
    .then((res) => {
      setapprovedProductsList(res.products);
      setappRecords(res.totalRecords);
      
      // ✅ Update the search component's count display if HSN filter is active
      if (updateSearchCountRef.current && hsnFilter) {
        updateSearchCountRef.current(res.totalRecords);
      }
      
      setloaderProduct("none");
    })
    .catch((err) => {
      setloaderProduct("none");
      console.log(err);
    });
}

  //<Start-Here> Refresh After Bulk Upload | Ticket : SL-943
  /**
   * Refresh the page
   */
  const refreshAfterBulkUpload = () => {
    applyLoader();
    globalFilter.pageNo = 1;
    setselectedPage(1);
    
    // Add price sorting if active
    if (priceSortOrder) {
      globalFilter["priceSort"] = priceSortOrder;
    }
    
    // Approved Products
    api.product
      //SL-975
      //.productsRetrieveall(approvedProducts(globalFilter))
      .productsRetrieveall(activeProductFilter(globalFilter))
      .then((res) => {
        setapprovedProductsList(res.products);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }
  //</End-Here> Refresh After Bulk Upload | Ticket : SL-943
  
  // Clear All Filters handler
  const clearAllFilters = () => {
    // Clear search
    setsearchPro("");

    // Clear HSN filter without calling API
    const { hsnFilter, ...filterWithoutHSN } = globalFilter;
    globalFilter = filterWithoutHSN;

    // Reset search type to Product Name
    setResetSearchType(prev => prev + 1);

    // Reset global filter to initial state
    globalFilter = {
      pageNo: 1,
      status: {
        active: true,
      },
       stockSts: {
        $or: [
                {
                  $and:[
                    {
                      $or:[
                          {combination : {$exists : false}},
                          {combination : {$size : 0}}
                      ]
                    },
                    { stock: {$gt : 0 }}
                  ]
                },
                {
                    
                  $and : [
                    { combination: { $exists: true, $ne: [] } },
                    //Has at least one combo with purchase_price & stock > 0
                    { combination: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, stock: { $gt: 0 } } } },
                    //No combo with purchase_price & stock == 0
                    { combination: { $not: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, $or: [{ stock: 0 }, { stock: { $exists: false }}] } } } }
                    //{ "combination.purchase_price" : { $exists: true, $ne: null }},
                    //{ "combination.stock": { $gt : 0 } },
                  ]
                },
          ],
        },
        prStatus: {
              $or: [
                      {
                        $and:[
                          {
                            $or:[
                                {combination : {$exists : false}},
                                {combination : {$size : 0}}
                            ]
                          },
                          { prSts: {$ne : "V_PENDING" }}
                        ]
                      },
                      {
                          
                        $and : [
                          { combination: { $exists: true, $ne: [] } },
                          { "combination.purchase_price" : { $exists: true, $ne: null }},
                          { "combination.prSts": { $ne : "V_PENDING"} },
                        ]
                      },
                ],
        },
        weightStatus: {
              $or: [
                      {
                        $and:[
                                {
                                  $or:[
                                        {combination : {$exists : false}},
                                        {combination : {$size : 0}}
                                  ]
                                },
                                {  sellerWeightChangeSts: { $ne : "V_PENDING" }}
                        ]
                      },
                      {
                          
                        $and : [
                                { combination: { $exists: true, $ne: [] } },
                                { "combination.purchase_price" : { $exists: true, $ne: null }},
                                { "combination.sellerWeightChangeSts": { $ne : "V_PENDING" }},
                        ]
                      },
              ],
        }
    };
    setselectedPage(1);

    // Call API only once at the end
    ApiCalling();
  }

  // Sl-906
  const handlePriceChange = ({ isCombination, lead, url, price, gst }) => {
    setCurPricePopupLead(lead);
    setCurPricePopupUrl(url);
    setCurPricePopupPrice(price);
    setCurPricePopupGst(gst);
    setNewPricePopupShow(true);
    setCurPricePopupCombState(isCombination);
  }

  const handleCallBackSuccessStatus = (callBackSuccess) => {
    if (callBackSuccess) {
      ApiCalling()
    }
  }

  const togglePriceSort = () => {
  let newSortOrder;
  if (priceSortOrder === null) {
    newSortOrder = 'asc';
  } else if (priceSortOrder === 'asc') {
    newSortOrder = 'desc';
  } else {
    newSortOrder = 'asc';
  }
  setPriceSortOrder(newSortOrder);
  
  // Apply sorting immediately to current products (no API call needed)
  const sortedProducts = sortProductsByPrice(approvedProductsList, newSortOrder);
  setapprovedProductsList(sortedProducts);
}
  // Price sorting functions
  const togglePriceSort1 = () => {
    let newSortOrder;
    if (priceSortOrder === null) {
      newSortOrder = 'asc';
    } else if (priceSortOrder === 'asc') {
      newSortOrder = 'desc';
    } else {
      newSortOrder = 'asc';
    }
    setPriceSortOrder(newSortOrder);
    
    applyLoader();
    globalFilter.pageNo = 1;
    setselectedPage(1);
    globalFilter["priceSort"] = newSortOrder;
    
    api.product
      .productsRetrieveall(activeProductFilter(globalFilter))
      .then((res) => {
        setapprovedProductsList(res.products);
        setappRecords(res.totalRecords);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }

  const clearPriceSort = () => {
  setPriceSortOrder(null);
  
  // Reload data without sorting
  applyLoader();
  globalFilter.pageNo = selectedPage;
  
  api.product
    .productsRetrieveall(activeProductFilter(globalFilter))
    .then((res) => {
      setapprovedProductsList(res.products); // No sorting applied
      setappRecords(res.totalRecords);
      removeLoader();
    })
    .catch((err) => {
      console.log(err);
      removeLoader();
    });
}

// sl-1224 sale filter
  const addSaleFilter = () => { 
    saleFilter = {
                      $or: [
                              {
                                $and:[
                                  {
                                    $or:[
                                        {combination : {$exists : false}},
                                        {combination : {$size : 0}}
                                    ]
                                  },
                                  { saleDiscount: true }
                                ]
                              },
                              {
                                  
                                $and : [
                                  { combination: { $exists: true, $ne: [] } },
                                  { "combination.purchase_price" : { $exists: true, $ne: null }},
                                  { saleDiscount: true },
                                ]
                              },
                        ],
                };
    getProducts();

  }
  const removeSaleFilter = () => { 
    saleFilter = null;
    delete globalFilter["saleFilter"];
    getProducts();
  }


  return (
    <>
      <div className="inventry-page" id="outer">
        <div className="d-flex inv_filter_cntn">

          <div className='topprodsearch d-flex align-items-center'>
            <ProductSKUSearch
                          filterSearch={filterSearch}
                          searchNewEnq={setsearchPro}
                          searchParam={searchParam}
                          from={"inventory"}
                          flag="Product"
                          apiCall={ApiCalling}
                          totalRcordId={totalRcordId}
                          searchByKeyword={searchByKeyword}
                          onHSNFilterChange={handleHSNFilterChange}
                          resetSearchType={resetSearchType}
                          onCountUpdate={handleCountUpdate} 
                        />
                        <PriceSortDropdown
      sortOrder={priceSortOrder}
      onToggleSort={togglePriceSort}
      onClearSort={clearPriceSort}
    />
          <div className={'sale-products-btn'}>
            { saleFilter !== null &&
            <span onClick={removeSaleFilter}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </span>}
            <button
              type="button"
              onClick={addSaleFilter}
            >
              <span>Sale Products</span>
            </button>
          </div>
          </div>

          <div className="">
            <BulkStockHandler />
            <NavLink exact to="/products" className="inv_tab_add_product">
                          <button className="pro_add_pro_invent">+ Add Product</button>
                        </NavLink>
          </div>

        </div>

        <div className="container_invent" id="orDeskContain">
          {/* New orders desktop */}
          <div class="tab table-responsive">
            {/* <Container> */}

            <table className="ord_table new-table-design" style={{ width: "100%", tableLayout: "fixed" }}>
              <thead>
                <tr className="table_ord_title_row">


                  <th className="thead_title pb-1" style={{ width: "35%" }}>
                    Product
                  </th>


                  {/* <th className="thead_title pb-1" style={{ width: "10%" }}>

                    Product Rating
                  </th> */}

                  <th className="thead_title" style={{ width: "10%" }}>
                    Stock
                    {/*<Start-Here> Bulk Stock Update Ticket: SL-761 */}
                    {/*</End-Here> Bulk Stock Update Ticket: SL-761 */}
                  </th>

                  <th className="thead_title" style={{ width: "15%" }}>
                    HSN Code
                  </th>
                  {/* Ticket: SL-698 */}
                  <th className="thead_title" style={{ width: "30%" }}>
                      Transfer Price
                    </th>
                  {curURL == 'active' &&
                    <th className='thead_title' style={{ "width": "5%" }}>TV Site Price  <OverlayTrigger
                      key="transfer"
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                          <p className='fs-8 f-500 order_page_tooltip_1'>Including Shipping Charges</p>
                        </Tooltip>
                      }
                    >
                      <i class="bi bi-info-circle ms-1"></i>
                    </OverlayTrigger>
                    </th>
                  }

                  <th className="thead_title" style={{ width: "10%" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {appRecords > 0 ? (
                  approvedProductsList.map((item, index) => {
                    let baseImg;
                    let lowestPrice = undefined;
                    let taxClass;
                    const pDetail = {
                      SKU: item.SKU,
                      productName: item.productName
                    }

                    item?.images.map((item) => {
                      if (item.baseImage === true) {
                        if (item.image.startsWith("products")) {
                          baseImg = item.image;
                        } else if (item.image.startsWith("mob")) {
                          baseImg = item.image;
                        } else {
                          let img = item.image.substr("41");
                          baseImg = img;
                        }
                      }
                    });
                    if (
                      item?.vendors[0] &&
                      item?.vendors[0]?.taxClass &&
                      item?.vendors[0]?.taxClass !== ""
                    ) {
                      taxClass = item.vendors[0].taxClass;
                    } else {
                      taxClass = item.taxClass;
                    }
                    let date = new Date(item.vendors[0].updated_at);
                    let d = date.toUTCString(item.vendors[0].updated_at);
                    let newd = d.substr(4, 12);

                    if (item?.combination) {
                      let vendorfirstComb = [];

                      if (item?.vendors?.[0]?.combination.length > 0) {
                        var offerArry = [];
                        var combarry = [];
                        var singleAttr = true;
                        if (
                          item?.combination[0] &&
                          item?.combination[0]?.value &&
                          item?.combination[0]?.value.length > 1
                        ) {
                          singleAttr = false;
                        }
                        item?.vendors?.[0]?.combination.map((vitem, vindex) => {
                          item?.combination?.map((pitem, pindex) => {
                            if (
                              pitem?.url === vitem?.url &&
                              vitem?.purchase_price &&
                              vitem?.purchase_price !== undefined &&
                              pitem?.active
                            ) {

                              if (!singleAttr) {
                                let com = "";

                                pitem?.value?.map((aitem, aindex) => {
                                  com = com + aitem;
                                  if (aindex !== pitem.value.length - 1) {
                                    com = com + " x ";
                                  }
                                });
                                if (
                                  vitem.vActive === "ACTIVE" ||
                                  vitem.vActive === "INACTIVE_REQ"
                                ) {
                                  combarry.unshift({
                                    com: com,
                                    price: vitem.purchase_price,
                                    saleDiscount: vitem.saleDiscount,
                                    lowestPrice: pitem.lowestPrice,
                                    recommendedTransferPrice: item?.combination[vindex]?.recommendedTransferPrice,
                                    "sitePrice": pitem.sPrice ? pitem.sPrice : pitem.price,
                                    status:
                                      vitem.vActive === "ACTIVE" ||
                                        vitem.vActive === "INACTIVE_REQ"
                                        ? "In Stock"
                                        : "Out of Stock",
                                    url: vitem.url,
                                    inventoryStock: pitem.inventoryStock,
                                    "stock": vitem?.stock,
                                    "prSts": vitem?.prSts,
                                    "sellerWeightChangeSts":vitem?.sellerWeightChangeSts
                                  });
                                } else {
                                  combarry.push({
                                    com: com,
                                    price: vitem.purchase_price,
                                    saleDiscount: vitem.saleDiscount,
                                    lowestPrice: pitem.lowestPrice,
                                    recommendedTransferPrice: pitem.recommendedTransferPrice,
                                    "sitePrice": pitem.sPrice ? pitem.sPrice : pitem.price,
                                    status:
                                      vitem.vActive === "ACTIVE" ||
                                        vitem.vActive === "INACTIVE_REQ"
                                        ? "In Stock"
                                        : "Out of Stock",
                                    url: vitem.url,
                                    inventoryStock: pitem.inventoryStock,
                                    "stock": vitem?.stock,
                                    "prSts": vitem?.prSts,
                                    "sellerWeightChangeSts":vitem?.sellerWeightChangeSts
                                  });
                                }

                                if (vitem.prSts && vitem.prSts === "V_PENDING") {
                                  let cmb = "";
                                  pitem.value.map((litem, lindex) => {
                                    cmb = cmb + litem;
                                    if (lindex !== pitem.value.length - 1) {
                                      cmb = cmb + " x "
                                    }
                                  })

                                  offerArry.push({ "cmb": cmb, "url": vitem.url })
                                }
                              }
                              else {
                                let com = {
                                  "com": pitem?.value?.[0],
                                  "price": vitem.purchase_price,
                                  "saleDiscount": vitem.saleDiscount,
                                  "lowestPrice": pitem.lowestPrice,
                                  "sitePrice": pitem.sPrice ? pitem.sPrice : pitem.price,
                                  "status": vitem.vActive === "ACTIVE" || vitem.vActive === "INACTIVE_REQ" ? "In Stock" : "Out of Stock",
                                  "url": vitem.url,
                                  "inventoryStock": pitem.inventoryStock,
                                  "recommendedTransferPrice": item?.combination[vindex]?.recommendedTransferPrice,
                                  "stock": vitem?.stock,
                                  "prSts": vitem?.prSts,
                                  "sellerWeightChangeSts":vitem?.sellerWeightChangeSts
                                }
                                if (vitem.vActive === "ACTIVE" || vitem.vActive === "INACTIVE_REQ") {
                                  combarry.unshift(com)
                                }
                                else {
                                  combarry.push(com)
                                }
                                if (vitem.prSts && vitem.prSts === "V_PENDING") {
                                  offerArry.push({ "cmb": pitem.value[0], "url": vitem.url })
                                }

                              }

                            }
                          })
                        })

                        return (
                          <ProductCard id={index}
                            inventoryStock={item?.inventoryStock}
                            taxClass={taxClass}
                            SKU={item?.SKU}
                            updatedon={newd}
                            urlKey={item?.urlKey}
                            //SL-975
                            //status={item?.vendors[0]?.vActive}
                            status={item.vendors[0]?.combination[0]?.stock > 0 ? 'ACTIVE' : 'INACTIVE' }
                            displayActualPrice={100}
                            curURL={curURL}
                            // lowestPrice={lowestPrice}
                            shortDescription={item?.shortDescription}
                            lead={item?._id}
                            productName={item?.productName}
                            //SL-975
                            //quantity={item?.vendors[0]?.stock}
                            quantity={item.vendors[0]?.combination[0]?.stock}
                            weight={item?.vendors[0]?.weight}
                            requestFrom="inventory"
                            offerForArr={offerArry}
                            vendActive={item?.vendors[0].active}
                            callback={productCheck}
                            image={baseImg}
                            vendor={item?.vendors[0]}
                            verTransPrice={verifyTransferPrice}
                            vendorfirstComb={vendorfirstComb}
                            combination={combarry}
                            changeproductStatusFun={changeproductStatus}
                            popupVisibility={setpopupVisibility}
                            fun={henfun}
                            recommendedPrice={item?.recommendedPrice}
                            recommendedTransferPrice={item?.recommendedTransferPrice}
                            sellerRatings={item?.sellerRatings}
                            getPriceMatchObject={getPriceMatchObject}
                            pDetail={pDetail}
                            callbackGetProducts={callbackResUpdate}
                            tabType="activeProducts"
                            updateSellerStock={updateSellerStock}
                            hsn={item?.vendors?.[0]?.HSN || ''}
                            updateProductHSN={updateProductHSN}
                            handlePriceRequest={handlePriceChange}
                            showButton={true}
                            showPriceMsg={true}
                          />
                        )

                      }
                      else {
                        return (
                          <ProductCard id={index}
                            inventoryStock={item?.inventoryStock}
                            taxClass={taxClass}
                            SKU={item?.SKU}
                            updatedon={newd}
                            urlKey={item?.urlKey}
                            lowestPrice={item?.lowestPrice}
                            lowestPriceMargin={item?.lowestPriceMargin}
                            displayActualPrice={item?.displayActualPrice}
                            curURL={curURL}
                            shortDescription={item?.shortDescription}
                            lead={item?._id}
                            verTransPrice={verifyTransferPrice}
                            productName={item?.productName}
                            price={item?.vendors?.[0].purchase_price}
                            saleDiscount={item?.vendors?.[0].saleDiscount}
                            quantity={item?.vendors[0].stock}
                            //SL-975
                            //status={item?.vendors[0]?.vActive}
                            status={item.vendors[0]?.stock > 0 ? 'ACTIVE' : 'INACTIVE'}
                            vendActive={item?.vendors[0].active}
                            vendor={item?.vendors[0]}
                            weight={item?.vendors[0].weight}
                            requestFrom="inventory"
                            callback={productCheck}
                            image={baseImg}
                            changeproductStatusFun={changeproductStatus}
                            popupVisibility={setpopupVisibility}
                            fun={henfun}
                            recommendedPrice={item?.recommendedPrice}
                            recommendedTransferPrice={item?.recommendedTransferPrice}
                            sellerRatings={item?.sellerRatings}
                            getPriceMatchObject={getPriceMatchObject}
                            pDetail={pDetail}
                            callbackGetProducts={callbackResUpdate}
                            tabType="activeProducts"
                            updateSellerStock={updateSellerStock} //Update Seller Stock
                            hsn={item?.vendors?.[0]?.HSN || ''}
                            updateProductHSN={updateProductHSN}
                            handlePriceRequest={handlePriceChange}
                            showButton={true}
                            showPriceMsg={true}
                          />
                        )

                      }
                    }
                    else {
                      return (
                        <ProductCard id={index}
                          inventoryStock={item.inventoryStock}
                          taxClass={taxClass}
                          SKU={item.SKU}
                          updatedon={newd}
                          urlKey={item.urlKey}
                          verTransPrice={verifyTransferPrice}
                          lowestPrice={item.lowestPrice}
                          lowestPriceMargin={item.lowestPriceMargin}
                          shortDescription={item.shortDescription}
                          lead={item._id}
                          productName={item.productName}
                          price={item.vendors[0].purchase_price}
                          saleDiscount={item?.vendors?.[0].saleDiscount}
                          vendor={item.vendors[0]}
                          quantity={item.vendors[0].stock}
                          //SL-975
                          //status={item.vendors[0].vActive}
                          status={item.vendors[0]?.stock > 0 ? 'ACTIVE' : 'INACTIVE'}
                          weight={item.vendors[0].weight}
                          vendActive={item.vendors[0].active}
                          requestFrom="inventory"
                          callback={productCheck}
                          image={baseImg}
                          changeproductStatusFun={changeproductStatus}
                          popupVisibility={setpopupVisibility}
                          fun={henfun}
                          getPriceMatchObject={getPriceMatchObject}
                          recommendedPrice={item.recommendedPrice}
                          recommendedTransferPrice={item.recommendedTransferPrice}
                          sellerRatings={item.sellerRatings}
                          pDetail={pDetail}
                          callbackGetProducts={callbackResUpdate}
                          tabType="activeProducts"
                          updateSellerStock={updateSellerStock} //Update Seller Stock
                          hsn={item?.vendors?.[0]?.HSN || ''}
                          updateProductHSN={updateProductHSN}
                          handlePriceRequest={handlePriceChange}
                          showButton={true}
                          showPriceMsg={true}
                        />
                      )
                    }

                  })) : loaderProduct === "block" ? <></> :
                  <>
                  </>
                }
                {loaderProduct === "none" && approvedProductsList.length === 0 && (
                  <tr>
                    <td colSpan={6} style={{ textAlign: 'center', padding: '1rem' }}>
                      No record found!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* </Container> */}
          </div>

          <PaginationNew
            number={appRecords}
            paginate={paginate}
            activ={selectedPage}
            comp={compforPaginationweb}
          />

          <div class="d-flex justify-content-center loader-bt" id="enNewLoader">
            <div
              class="spinner-border"
              role="status"
              style={{ display: loaderProduct }}
            >
              <span class="sr-only"></span>
            </div>
          </div>
        </div>
        {showMatchModal &&
          <MatchPriceModal
            otherPrice={matchObject?.lowestPrice}
            getProducts={getProducts}
            show={showMatchModal}
            SKU={matchObject?.SKU}
            url={matchObject?.url}
            productId={matchObject?.productId}
            handleClose={closeMatchModal}
            receivedFrom="Inventory"
          />
        }
        {approvedProductsList.length > 0 ? (
          <div
            id="popup1"
            className="overlay"
            style={{ display: isPopupVisible }}
          >
            <Popup
              name={approvedProductsList[currDetail].productName}
              price={null}
              SKU={approvedProductsList[currDetail].SKU}
              popupVisibility={setpopupVisibility}
              images={approvedProductsList[currDetail].images}
              description={approvedProductsList[currDetail].description}
              sdescription={approvedProductsList[currDetail].shortDescription}
              descriptionNew={approvedProductsList[currDetail].descriptionNew}
              specificationNew={approvedProductsList[currDetail].specificationNew}
              callback={productCheck}
              lead={approvedProductsList[currDetail]._id}
            />
          </div>
        ) : (
          <></>
        )}

        {updtProVisibility === true && combAttri.length > 0 && (
          <UpdtProPopup2
            lead={clickedUpdateNo}
            productName={selectedProductPopup}
            callbackResFun={callbackResUpdate}
            combattr={combAttri}
            img={selectedImgPopup}
            product={currentProupdt}
            detail={updtPopuprel}
            Popupvisible="block"
            from="approved-Pro"
            Popupvisibilityfun={checkpopupvisibility}
          />
        )}
        {updtProVisibility === true && combAttri.length < 1 && (
          <UpdtProPopup2
            lead={clickedUpdateNo}
            img={selectedImgPopup}
            productName={selectedProductPopup}
            detail={updtPopuprel}
            callbackResFun={callbackResUpdate}
            Popupvisible="block"
            from="approved-Pro"
            Popupvisibilityfun={checkpopupvisibility}
          />
        )}
        {/* Off canvas for verify transfer price */}

        <Offcanvas
          show={offcanshow}
          onHide={handleCloseoffcan}
          placement="bottom"
          className="h-40 offcan_transfer_price"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="m-auto">
              Verify Transfer Price
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="m-0 p-0">
            {offcanstate === "ask" ? (
              <Container>
                <Card className=" mb-2 theme-outline  ">
                  <p className="theme-col px-3 pt-2 pb-0 f-600 fs-14 curr_trans_p text-center">
                    Current Transfer Price (incl. {taxClass}% GST) :
                    <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                      {" "}
                      <i className="fa fa-inr"></i> {curroffCanPrice}{" "}
                    </span>
                  </p>
                  {curroffCanPrice > lowestPrice ? (
                    <p className="px-3 pt-2 pb-0 f-600 fs-11 text-center">
                      <span className="text-warning fs-17">
                        <i className="bi bi-exclamation-triangle-fill"></i>
                      </span>
                      <span className="other_seller_price">
                        {" "}
                        Other seller's price(incl. GST) :
                      </span>
                      <span className="f-600 fs-13 ms-1 mt-1 text-primary">
                        {" "}
                        <i className="fa fa-inr"></i> {lowestPrice}{" "}
                      </span>
                    </p>
                  ) : (
                    <></>
                  )}
                  <p className="iscorr_trans_p text-center fs-14">
                    Is this the correct price{" "}
                    <i class="fa fa-question" aria-hidden="true"></i>
                  </p>

                  <Row className="text-center my-3 ">
                    <div className="col-6 pt-1">
                      <button
                        className="yes-button1 offcan_yes_button"
                        onClick={() => yesVerifyPrice()}
                      >
                        Yes
                      </button>
                    </div>
                    <div className="col-6 pt-1">
                      <button
                        className="yes-button1 offcan_no_button"
                        onClick={() => noVerifyPrice()}
                      >
                        No
                      </button>
                    </div>
                  </Row>
                </Card>
              </Container>
            ) : offcanstate === "askNewPrice" ? (
              <Container>
                <Card className=" mb-2 theme-outline  ">
                  <p className="theme-col px-3 pt-2 pb-0 f-600 fs-14 curr_trans_p text-center">
                    Current Transfer Price (incl. {taxClass}% GST) :
                    <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                      {" "}
                      <i className="fa fa-inr"></i> {curroffCanPrice}{" "}
                    </span>
                  </p>
                  <p className="text-center fs-14 iscorr_trans_p">
                    Please Enter New Transfer Price (Incl. GST) :
                  </p>
                  <div className="text-center">
                    <i className="fa fa-inr me-2"></i>
                    <input
                      type="number"
                      onChange={(e) => setnewoffcanPrice(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                      className="inr-input pl-1"
                    ></input>
                  </div>
                  <Row className="text-center my-3 ">
                    <div className="col-12 pt-1">
                      <button
                        className="yes-button1 ff_pop"
                        onClick={() => checkNewPrice()}
                      >
                        Submit
                      </button>
                    </div>
                  </Row>
                </Card>
              </Container>
            ) : (
              <Container>
                <Card className=" mb-2 theme-outline  ">
                  <p className="new_req_price_head text-center pt-3 pb-0">
                    New Requested Transfer Price:
                    <span className="f-600 fs-17 ms-1 mt-1 text-black">
                      {" "}
                      <i className="fa fa-inr"></i> {newoffcanPrice}{" "}
                    </span>
                  </p>
                  <span className="text-red fs-12 px-3 pb-2 f-700 note_trans_price">
                    Note : It will take 48 to 72 hrs for our team to verify your
                    new transfer price request. Meanwhile you can -
                  </span>

                  <div
                    onChange={(e) => setseloption(e.target.value)}
                    className="px-4"
                  >

                    <input
                      type="radio"
                      id="vehicle1"
                      className="input-chk"
                      name="opt"
                      value="continueSame"
                      defaultChecked
                    />
                    <label className="theme-col fs-13 mx-2 f-500 new_req_price_head">
                      {" "}
                      Continue selling with the current price
                    </label>
                    <br></br>
                    <input
                      type="radio"
                      id="vehicle2"
                      name="opt"
                      className="input-chk"
                      value="makeInactive"
                    />
                    <label className="theme-col fs-13 mx-2 f-500 new_req_price_head">
                      {" "}
                      Make it inactive
                    </label>
                    <br></br>

                    <div className="text-right mb-2">
                      <input
                        type="submit"
                        id="sub_newreq"
                        className="yes-button1 "
                        onClick={() => newPriceReq()}
                      />
                    </div>
                  </div>
                </Card>
              </Container>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>
      {/* Toast */}
      <Toast
        show={showToast}
        className="ToastHome"
        onClose={() => setshowToast(false)}
      >
        <Toast.Header>
          <strong className="me-auto">Message</strong>
        </Toast.Header>
        <Toast.Body>{ToastMsg}</Toast.Body>
      </Toast>

      {/* Filter Modal */}

      {/* SL-906 */}
      <NewPriceReqPopup
        offcanshow={newPricePopupShow}
        handleCloseoffcan={() => setNewPricePopupShow(false)}
        lead={curPricePopupLead}
        url={curPricePopupUrl}
        pPrice={curPricePopupPrice}
        currGst={curPricePopupGst}
        isCombination={curPricePopupCombState}
        handleCallBackSuccessStatus={handleCallBackSuccessStatus}
        receivedFrom="Inventory"
      />  
    </>
  );
}

export default ActiveProducts;